import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from 'react-router-dom';
// import {  } from "../../../../Constant/api";
// import { slugs } from "../../../../Constant/slugs";
// import { AlertComponent } from "../../../AlertComponent";
// import { CustomButton } from "../../../CustomButtom";
import ImageUpload from "./ImageUpload";
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, AdsPUTApiToken } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
const studentRoles = ["subscriber", "student"]
export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)
  const Login = useSelector((state) => state.LoginState);

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [ProfilePicture, setProfilePicture] = React.useState(FetchData.meta.user_profile_picture)
  const [VerificationStatus, setVerificationStatus] = React.useState(FetchData.meta.verification_status)
  const [userID, setUserID] = React.useState(FetchData.meta.user_id)
  const [userName, setUserName] = React.useState(FetchData.meta.user_name)
  const [Password, setPassword] = React.useState(FetchData.meta.user_phone_number)
  const [userEmail, setUserEmail] = React.useState(FetchData.meta.user_email)
  const [GuardianName, setGuardianName] = React.useState(FetchData.meta.guardian_name)
  const [GuardianNumber, setGuardianNumber] = React.useState(FetchData.meta.guardian_phone_number)
  const [Teacher, setTeacher] = React.useState(FetchData.meta.teacher)
  const [Shift, setShift] = React.useState(FetchData.meta.shift)
  const [DOB, setDOB] = React.useState(FetchData.meta.date_of_birth)
  const [deviceid, setdeviceid] = React.useState(FetchData.meta.device_id)

  const [TeacherList, setTeacherList] = React.useState([])
  const [TeacherListLoaded, setTeacherListLoaded] = React.useState(false)
  const [ExamList, setExamArray] = React.useState([])
const [expiryDate, setExpiryDate] = React.useState(FetchData.meta.expiry_date)
  const [batchYear, setBatchYear] = React.useState(FetchData.meta.batch_year)

  const [Datapassword, setDataPassword] = React.useState(FetchData.id == "" ? true : false)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const AfterUserCreate = (id) => {
    const data = {
      "title": Title,
      "status": "publish",
      "author": id,
      "meta": {
        "user_role": "online_student",
        "user_profile_picture": ProfilePicture,
        "user_phone_number": `${Password}`,
        "class_code": `${Password}`,
        "verification_status": VerificationStatus,
        "user_id": `${id}`,
        "user_name": `${userName}`,
        "user_email": `${userName}@akbeducation.com`,
        "guardian_name": `${GuardianName}`,
        "guardian_phone_number": `${GuardianNumber}`,
        "teacher": `${Teacher}`,
        "shift": `${Shift}`,
        "date_of_birth": `${DOB}`,
        "roll_number": `${userName}`,
        "device_id": `${deviceid}`,
        "expiry_date":`${expiryDate}`,
        "batch_year":`${batchYear}`
      }
    }
    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_user_data)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Book Added Successfully")
          history.push(`${slugs.physical_student_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_user_data, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  const EditInfo = () => {
    setReload(true)

    if (ID == "") {
      const dataWithPassword = {
        "username": userName,
        "email": `${userName}@akbeducation.com`,
        "password": Password,
        "roles": "physical_student"
      }
      AdsPOSTApi(dataWithPassword, "users")
        .then(res => {
          AfterUserCreate(res.data.id)
        })
        .catch(e => {
          console.log(e)
          setAlertShow(true)
          setAlertcomp("Roll Number Already used")
        }
        )
    }
    else {
      if (Datapassword) {
        const dataWithPassword = {
          "password": Password,
          "roles": "physical_student"
        }
        if (Login.userID !== userID)
          AdsPUTApi(dataWithPassword, `users`, `${userID}`)
            .then(res => {
              AfterUserCreate(userID)
            })
            .catch(e =>
              console.log(e)
            )
        else {
          setAlertShow(true)
          setAlertcomp("You are not allowed to cahnge owns password")
          setReload(false)
        }
      }
      else {
        const data = {
          "roles": "physical_student"
        }
        AdsPUTApi(data, `users`, `${userID}`)
          .then(res => {
            AfterUserCreate(userID)
          })
          .catch(e =>
            console.log(e)
          )
      }
    }
  }

  useEffect(() => {
    GetAll()
  }, [])
  const GetAll = () => {
    GetAllProjects({
      per_page: 4999,
      "filter[meta_query][1][key]": "user_role",
      "filter[meta_query][1][value][0]": `staff`,
      "filter[meta_query][1][compare]": "=",
    })
    BatchList()

  }
  const BatchList = () => {
    AdsGETApiAuth(
      { per_page: 1000, _fields: "id,slug,title,meta.exam_type" },
      slugs.db_slug_paid_exam
    )
      .then((res) => {
        setExamArray(res.data.filter(a => a.meta.exam_type == "UBT"))
      })
      .catch(e => {
        console.log(e)
      })
  }


  const GetAllProjects = (params) => {
    setReload(true)
    AdsGETApiAuth(params, slugs.db_slug_user_data)
      .then((res) => {
        setTeacherList(res.data)
        setTeacherListLoaded(true)
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }




  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Student Information </center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Student Name </td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Verification Status</td>
                <td className="col-6">
                  <CustomButton setData={setVerificationStatus} Data={VerificationStatus} DataValue={"verified"} />
                  <CustomButton setData={setVerificationStatus} Data={VerificationStatus} DataValue={"None"} />
                </td>
              </tr>
              <tr>
                <td className="col-3">Profile Picture</td>
                <td className="col-6">
                  <ImageUpload
                    ImageUrl={ProfilePicture}
                    setImageUrl={setProfilePicture}
                  />
                </td>
              </tr>

              <tr>
                <td className="col-3">Teacher</td>
                <td className="col-6">
                  {TeacherList.map((item, index) => (
                    <span key={index}>
                      <CustomButton setData={setTeacher} Data={Teacher} DataValue={item.title.rendered} />

                    </span>
                  ))}

                </td>
              </tr>
              {Teacher !== "" && TeacherListLoaded &&
                <tr>
                  <td className="col-3">Shift</td>
                  <td className="col-6">
                    {/* {JSON.parse(TeacherList.filter(a=>a.title.rendered==Teacher)[0].meta.schedules).map((item, index) => (
                      <span key={index}>
                        <CustomButton setData={setTeacher} Data={Teacher} DataValue={item.title.rendered} />

                      </span>
                    ))} */}
                    {Object.values(JSON.parse(TeacherList.filter(a => a.title.rendered == Teacher)[0].meta.schedules)).map((item, index) => (
                      <span key={index}>
                        <CustomButton setData={setShift} Data={Shift} DataValue={item} />
                      </span>
                    ))}

                  </td>
                </tr>

              }
              <tr>
                <td className="col-3">Roll Number</td>
                <td className="col-6">
                  {ID == "" ?
                    <input className="input-common"
                      value={userName} placeholder="Roll Number"
                      onChange={(event) => { setUserName(event.target.value) }}
                    />
                    :
                    <div className="input-common" >{userName}</div>
                  }
                </td>
              </tr>
              <tr>
                <td className="col-3">Phone Number</td>
                <td className="col-6">
                  {Datapassword ?
                    <input className="input-common"
                      value={Password} placeholder="Phone Number"
                      onChange={(event) => { setPassword(event.target.value) }}
                    />
                    :
                    <div>
                      {Password}
                      <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}
                        onClick={() => {
                          setDataPassword(true)
                          // setPassword("")
                        }}
                      >
                        <div className={"passive-option"}>
                          Change Phone Number
                        </div>
                      </button>
                    </div>
                  }
                </td>
              </tr>
              <tr>
                <td className="col-3">Device ID</td>
                <td className="col-6">
                  <div>
                    {deviceid}
                    <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}
                      onClick={() => {
                        setdeviceid("")
                      }}
                    >
                      <div className={"passive-option"}>
                        Clear
                      </div>
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">Guardian Name </td>
                <td className="col-6">
                  <input className="input-common"
                    value={GuardianName} placeholder="Guardian Name"
                    onChange={(event) => { setGuardianName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Guardian Number </td>
                <td className="col-6">
                  <input className="input-common"
                    value={GuardianNumber} placeholder="Guaradian Number"
                    onChange={(event) => { setGuardianNumber(event.target.value) }}
                  />
                </td>
              </tr>
                <tr>
                <td className="col-3">Expiry Date</td>
                <td className="col-6">
                  <input className="input-common" type="date"
                    value={expiryDate} placeholder="Expiry Date"
                    onChange={(event) => { setExpiryDate(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Batch Year</td>
                <td className="col-6">
                  <input className="input-common"
                    value={batchYear} placeholder="Batch Year"
                    onChange={(event) => { setBatchYear(event.target.value) }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          {Login.userRole == "author" &&
            <div className="row center m-2">
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-4"
                  onClick={() => {
                    EditInfo()
                  }}
                >
                  Update Student
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      {
        reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div >
  )

}